import { render, staticRenderFns } from "./ViewPermissionModal.vue?vue&type=template&id=8831dae8&scoped=true"
import script from "./ViewPermissionModal.vue?vue&type=script&lang=js"
export * from "./ViewPermissionModal.vue?vue&type=script&lang=js"
import style0 from "./ViewPermissionModal.vue?vue&type=style&index=0&id=8831dae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8831dae8",
  null
  
)

export default component.exports